module.exports = {"341824100":"华阳镇","341824101":"临溪镇","341824102":"长安镇","341824103":"上庄镇","341824104":"扬溪镇","341824105":"伏岭镇","341824106":"金沙镇","341824107":"瀛洲镇","341824201":"板桥头乡","341824202":"家朋乡","341824203":"荆州乡","341824400":"生态工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341824.json
// module id = 1062
// module chunks = 0